import { Outlet } from "react-router-dom";
import { NoIndex } from "./noIndex";

export const AuthLayout = () => (
  <>
    <NoIndex />
    <Outlet />
  </>
);
